import { render, staticRenderFns } from "./DialogImportarSignatarios.vue?vue&type=template&id=b21dc9ce&scoped=true"
import script from "./DialogImportarSignatarios.vue?vue&type=script&lang=js"
export * from "./DialogImportarSignatarios.vue?vue&type=script&lang=js"
import style0 from "./DialogImportarSignatarios.vue?vue&type=style&index=0&id=b21dc9ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21dc9ce",
  null
  
)

export default component.exports